<div class="pc-text pc-component" [ngClass]="item.class">
    <lh-header-bar [content]="item.title"></lh-header-bar>
    <section class="pc-richtext" [vnDynamicHtml]="item.text"></section>
</div>
